export const USE_TRIFFIN_NAV_LABEL = "Use Triffin";
export const USE_TRIFFIN_NAV_HREF = "/questionnaire";
const USE_TRIFFIN_NAV_ATTR = "data-viable-use-triffin";

function readQuestionnaireHref(propsAttr: string | null): string {
	if (!propsAttr) return USE_TRIFFIN_NAV_HREF;
	try {
		const parsed: unknown = JSON.parse(propsAttr);
		if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return USE_TRIFFIN_NAV_HREF;
		const href = (parsed as { questionnaireHref?: unknown }).questionnaireHref;
		if (typeof href !== "string") return USE_TRIFFIN_NAV_HREF;
		const trimmed = href.trim();
		return trimmed === "" ? USE_TRIFFIN_NAV_HREF : trimmed;
	} catch {
		return USE_TRIFFIN_NAV_HREF;
	}
}

/**
 * Inserts "Use Triffin" at the start of the Webflow navbar menu. Idempotent:
 * a second embed mount on the same page does not add another link.
 */
export function injectUseTriffinNavLink(propsAttr?: string | null): void {
	if (typeof document === "undefined") return;

	const href = readQuestionnaireHref(propsAttr ?? null);
	const menus = document.querySelectorAll(".navbar-container .nav-links");
	for (const navLinks of menus) {
		if (navLinks.querySelector(`[${USE_TRIFFIN_NAV_ATTR}]`)) continue;
		const alreadyLabeled = [...navLinks.querySelectorAll("a")].some(
			(anchor) => anchor.textContent?.trim() === USE_TRIFFIN_NAV_LABEL,
		);
		if (alreadyLabeled) continue;

		const link = document.createElement("a");
		link.href = href;
		link.className = "nav-link";
		link.textContent = USE_TRIFFIN_NAV_LABEL;
		link.setAttribute(USE_TRIFFIN_NAV_ATTR, "");
		navLinks.insertBefore(link, navLinks.firstChild);
	}
}
